import { api } from "constants/RotasAPI";
import { useProcessosJudiciaisContext } from "context/gestaoCobranca/ProcessosJudiciaisContext";
import { useGetBaixarAnexoProcessoJudicial } from "hooks/anexos/useGetBaixarAnexoProcessoJudicial";
import { useGetAnexosVinculadosAoProcesso } from "hooks/processosJudiciais/useGetAnexosVinculadosAoProcesso";
import { Row } from "react-bootstrap";
import CloudAnexo from "shared/components/input/AsyncCloudAnexo";
import { FileToBase64 } from "shared/util/functions/file/FileFunctions";
import { http } from "shared/util/http";
import { queryClient } from "shared/util/queryClient";
import { AnexoType } from "types/anexo/AnexoType";
import { ProcessoJudicialAnexoDTO } from "types/dto/ProcessoJudicialAnexoDTO";

interface AnexarDocumentosProcessosJudiciaisProps {
  processoJudicialId: number;
}
const AnexarDocumentosProcessosJudiciais: React.FC<AnexarDocumentosProcessosJudiciaisProps> = (props) => {
  const { isVisualizacao } = useProcessosJudiciaisContext();
  const { data: anexos } = useGetAnexosVinculadosAoProcesso({
    processoJudicialId: props.processoJudicialId,
    isVisualizacao,
  });
  const { baixarAnexo } = useGetBaixarAnexoProcessoJudicial();

  const onAddAnexo = async (file: File): Promise<any> => {
    let base64 = "";
    await FileToBase64(file).then((result: string) => (base64 = result));
    const anexo = {
      processoJudicialId: props.processoJudicialId,
      nome: file.name,
      base64: base64,
    } as ProcessoJudicialAnexoDTO;
    queryClient.invalidateQueries(["anexos-processo-isVisualizacao-true", props.processoJudicialId]);
    return http.post(api.processosJudiciaisAnexos.postProcessoJudicialAnexo, anexo);
  };

  const onRemoveAnexo = async (anexo: AnexoType): Promise<any> => {
    const URL = api.processosJudiciaisAnexos.deleteProcessoJudicialAnexo.concat(
      `?id=${anexo.id}&uuidBucket=${anexo.uuidBucket}`
    );
    queryClient.invalidateQueries(["anexos-processo-isVisualizacao-true", props.processoJudicialId]);
    return http.delete(URL);
  };

  const renderAnexarDocumento = () => {
    return (
      <Row className="mt-3">
        <CloudAnexo
          onAddAnexo={onAddAnexo}
          onRemoveAnexo={onRemoveAnexo}
          onDownloadAnexo={baixarAnexo}
          limiteDeAnexos={5}
          tamanhoMaximoEmMegaByteDoAnexo={5}
          isVisualizacao={isVisualizacao}
          anexos={anexos}
          accept=".pdf,.doc,.xls,.png,.jpeg,.csv,.docx,.xlsx"
          extensoesAceitas={["pdf", "doc", "xls", "png", "jpeg", "csv", "docx", "xlsx"]}
        />
      </Row>
    );
  };
  return (
    <div>
      <h2 className="sub-titulo mb-1">Anexar</h2>
      <span>Adicione aqui documentos complementares ao processo</span>
      {renderAnexarDocumento()}
    </div>
  );
};

export default AnexarDocumentosProcessosJudiciais;
